<template>
  <div class="row justify-content-center no-gutters">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :background-color="bg_color"
      :color="icon_color"
    ></loading>
    <div class="col col-md-9">
      <div class="row justify-content-center">
        <div v-if="subscriptions" v-for="(subs, index) in subscriptions" :key="index" class="mt-2 col-md-6 col-lg-4 col-xl-4 max-xl-670 product-card">
          <div class="card card-subscription background--card py-5" v-if="subs.subscriptionStatus === 'Subscribed'">
            <div class="card-header">
              <!--              {{ subs.Id }}-->
              <div v-if="subs.Subscription_Image_URL__c === '' || subs.Subscription_Image_URL__c === null" class="text-center">
                <img :src="default_icon" width="60px" height="auto"/>
              </div>
              <div v-else class="text-center">
                <img :src="base_url + subs.Subscription_Image_URL__c" width="60px" height="auto"/>
              </div>
              <p v-if="subs.price === '' || subs.price === null" data-current-language="tr_TR" class="h5" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">
                <span style="visibility: hidden !important;">No Price</span>
              </p>
              <p v-else data-current-language="tr_TR" class="h5 subs-card-content-price" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">
                ${{ Number(subs.price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                <span v-if="subs.purchase_option_number === 12"> per year</span>
                <span v-else-if="subs.purchase_option_number === 6"> per bi-annual</span>
                <span v-if="subs.purchase_option_number === 1"> per month</span>
              </p>

              <p data-current-language="tr_TR" class="h5 subs-card-content-title">{{ subs.Name }}</p>
            </div>
            <div class="card-body" style="min-height: 250px">
              <div class="text-center">
                <!--                <span-->
                <!--                  data-current-language="tr_TR"-->
                <!--                  style="display: block">-->
                <!--                  <p style="display: inline-block;"><svg-rndr svg="check.svg" :width="16" style="float: left; padding-right: 5px !important;"/>{{ subs.Subscription_Description__c }}</p>-->
                <!--                </span>-->
                <div style="display: table; height: 190px; overflow: hidden; width: 100%;">
                  <div style="display: table-cell; vertical-align: middle;">
                    <div>
                      <p style="display: inline-block; height: 169px;overflow-y: auto;" v-if="subs.Subscription_Description__c">
                        <!--                        <svg-rndr svg="check.svg" :width="16" style="float: left; padding-right: 5px !important;"/>-->
                        {{ subs.Subscription_Description__c }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="subs.subscriptionStatus === 'Subscribed'">
                  <span v-if="subs.status.toLowerCase() === 'pending cancellation'" class="cancellation-message">
                    <span>Access to this subscription <br> will end on {{ subs.subs_end }}</span>
                  </span>
                  <span v-else class="cancellation-message-1">
<!--                    <span style="">Last access date {{ to_take }}</span>-->
                  </span>
                </div>
                <div v-else>
                  <span class="cancellation-message">
                    <span style="visibility: hidden;">- <br> -</span>
                  </span>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-md-8">
                  <span role="alert" class="alert alert-" style="display: none;">
                    <div class="row">
                      <div class="col-1">
                        <span class="flash-icon"><!----></span>
                      </div>
                      <div class="col"><span></span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <!--            {{ subs }}-->
            <div class="text-center" style="padding-top: 1rem !important;">
              <div v-if="subs.subscriptionStatus === 'Subscribed'" >
                <div v-if="subs.status.toLowerCase() !== 'pending cancellation'">
                  <div class="dropdown">
                    <p class="text-white" style="border: none !important; width: 150px;">SUBSCRIBED</p>
                    <!-- <a href="#" class="btn btn-outline-primary btn-outline-subscribed" style="border: none !important; width: 150px;">SUBSCRIBED <span class="arrow-down"></span></a>
                    <div class="dropdown-content">
                      <a href="#" v-on:mouseover="handleChange(1)" v-on:mouseleave="handleChange(0)" @click="openOptions(subs)">Manage Subscription</a>
                    </div> -->
                  </div>
                </div>
                <div v-else>
                  <span class="btn cancelled-btn">CANCELLED</span>
                </div>
              </div>
              <div v-else>
                <a href="#" class="btn btn-primary" @click="handleSubscribeModal(subs)">
                  <span data-current-language="tr_TR">SUBSCRIBE</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- cancellation modal-->
    <modal
      name="options-modal"
      width="100%"
      height="auto">
      <div v-if="cancel_step === 1" style="display: block !important; width: 100% !important;">  <!-- step 1 -->
        <div class="row no-gutters">
          <div class="col col-12">
            <div class="text-center">
              <p class="h5" style="font-weight: 800">{{ dialogTitle }}</p>
            </div>
            <!--            temporary disabled-->
            <!--            <div v-if="(customer_group === 'sc2' || customer_group === 'SC2') && (tocancelData.chargebee_subscription_id !== '' || tocancelData.chargebee_subscription_id !== null)" class="text-center sub-modal">-->
            <!--              <div>-->
            <!--                <div v-if="tocancelData.Subscription_Image_URL__c === '' || tocancelData.Subscription_Image_URL__c === null" class="text-center">-->
            <!--                  <img :src="default_icon" width="60px" height="auto"/>-->
            <!--                </div>-->
            <!--                <div v-else class="text-center">-->
            <!--                  <img :src="base_url + tocancelData.Subscription_Image_URL__c" width="60px" height="auto"/>-->
            <!--                </div>-->
            <!--                <p v-if="tocancelData.price === '' || tocancelData.price === null" data-current-language="tr_TR" class="h5" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">-->
            <!--                  <span style="visibility: hidden !important;">No Price</span>-->
            <!--                </p>-->
            <!--                <p v-else data-current-language="tr_TR" class="h5" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">-->
            <!--                  ${{ Number(tocancelData.price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}-->
            <!--                  <span v-if="tocancelData.purchase_option_number === 12"> per year</span>-->
            <!--                  <span v-else-if="tocancelData.purchase_option_number === 6"> per bi-annual</span>-->
            <!--                  <span v-if="tocancelData.purchase_option_number === 1"> per month</span>-->
            <!--                </p>-->

            <!--                <div class="text-center">-->
            <!--                  <span-->
            <!--                    data-current-language="tr_TR"-->
            <!--                    style="display: block">-->
            <!--                    <p style="display: inline-block;" v-if="tocancelData.Subscription_Description__c">-->
            <!--                      {{ tocancelData.Subscription_Description__c }}-->
            <!--                    </p>-->
            <!--                  </span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div v-else class="text-center sub-modal"> &lt;!&ndash; not sc2 &ndash;&gt;-->
            <div class="text-center sub-modal"> <!-- not sc2 -->
              <div>
                <div v-if="tocancelData.Subscription_Image_URL__c === '' || tocancelData.Subscription_Image_URL__c === null" class="text-center">
                  <img :src="default_icon" width="60px" height="auto"/>
                </div>
                <div v-else class="text-center">
                  <img :src="base_url + tocancelData.Subscription_Image_URL__c" width="60px" height="auto"/>
                </div>
                <p v-if="tocancelData.price === '' || tocancelData.price === null" data-current-language="tr_TR" class="h5" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">
                  <span style="visibility: hidden !important;">No Price</span>
                </p>
                <p v-else data-current-language="tr_TR" class="h5" style="margin-top: 20px !important; color: #9db5e8;font-family: sans-serif;">
                  ${{ Number(tocancelData.price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                  <span v-if="tocancelData.purchase_option_number === 12"> per year</span>
                  <span v-else-if="tocancelData.purchase_option_number === 6"> per bi-annual</span>
                  <span v-if="tocancelData.purchase_option_number === 1"> per month</span>
                </p>

                <div class="text-center">
                  <span
                    data-current-language="tr_TR"
                    style="display: block">
                    <p style="display: inline-block;" v-if="tocancelData.Subscription_Description__c">
<!--                      <svg-rndr svg="check.svg" :width="16" style="float: left; padding-right: 5px !important;"/>-->
                      {{ tocancelData.Subscription_Description__c }}
                    </p>
                  </span>
                </div>

              </div>
              <div style="display: table; height: 160px; overflow: hidden; width: 100%; padding: 20px; background-color: #4f6da0 !important; margin-bottom: 20px !important; margin-top: 20px !important;">
                <div style="display: table-cell; vertical-align: middle;">
                  <div>
                    <span class="text-center cancel-emp-text">
                     To upgrade or manage any of your subscriptions, please email us at <a :href="'mailto:' + cs_mail_address" class="mailto">{{ cs_mail_address }}</a>.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col col-12 text-center">
            <!--            temporary disable-->
            <!--            <span v-if="(customer_group === 'sc2' || customer_group === 'SC2') && (tocancelData.chargebee_subscription_id !== '' || tocancelData.chargebee_subscription_id !== null)" style="display: block">-->
            <!--              <a href="#" class="btn btn-primary" @click="handleChangeStep()" style="margin-right: 20px; background-color: transparent !important; background-image: none !important; color: #1d203a; !important">-->
            <!--                <span data-current-language="tr_TR">Cancel Subscription</span>-->
            <!--              </a>-->
            <!--              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideModal()" style="margin-right: 20px;">-->
            <!--                <span data-current-language="tr_TR">Close</span>-->
            <!--              </a>-->
            <!--            </span>-->
            <!--            <span v-else style="display: block">-->
            <!--              <a href="#" class="btn btn-primary" @click="handleChangeStep()" style="margin-right: 20px; background-color: transparent !important; background-image: none !important; color: #1d203a; !important">-->
            <!--                <span data-current-language="tr_TR">Cancel Subscription</span>-->
            <!--              </a>-->
            <span style="display: block">
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideModal()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Close</span>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div v-else style="display: block !important; width: 100% !important;">
        <div class="row no-gutters">
          <div class="col col-12">
            <div class="text-center">
              <p class="h5" style="font-weight: 800">{{ dialogTitle }}</p>
            </div>
            <!--            temporary disable-->
            <!--            <div v-if="(customer_group === 'sc2' || customer_group === 'SC2') && (tocancelData.chargebee_subscription_id !== '' || tocancelData.chargebee_subscription_id !== null)">-->
            <!--              <div>-->
            <!--                <div class="text-center" style="padding: 20px;"><span class="text-center" style="font-weight: 500; font-size: 18px;">You have requested to cancel your subscription.</span></div>-->
            <!--                <div class="sub-modal-cancel">-->
            <!--                  <div style="display: table-cell; vertical-align: middle;">-->
            <!--                    <div>-->
            <!--                      <div class="text-center" style="padding-bottom: 20px;">Your subscription costs $ {{ Number(price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }} per {{ term }} </div>-->
            <!--                      <div class="text-center">-->
            <!--                      <span v-if="nextdue_is_morethan === true" class="text-center cancel-emp-text">-->
            <!--                        If you confirm, your last payment will be on <strong>{{ next_due_date }},</strong> <br>-->
            <!--                        Your access to your subscription will stop on <strong>{{ to_take }}</strong>.-->
            <!--                      </span>-->
            <!--                        <span v-else class="text-center cancel-emp-text">-->
            <!--                        If you confirm, access to your subscription will stop on <strong>{{ to_take }}</strong>.-->
            <!--                      </span>-->
            <!--                      </div>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--              </div>-->
            <!--            </div>-->
            <!--            <div v-else>-->
            <div>
              <div>
                <div class="sub-modal-cancel">
                  <div style="display: table-cell; vertical-align: middle;">
                    <div>
                      <div class="text-center">
                        To cancel your subscription, please email us at <a :href="'mailto:' + cs_mail_address" class="mailto">{{  cs_mail_address }}</a>
                      </div>
                      <div class="text-center">
                        <span class="text-center cancel-emp-text">
                        All cancellations are subject to a notice period of 30 days.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!--                <div class="text-center" style="padding: 20px;"><span class="text-center" style="font-weight: 500; font-size: 18px;">To cancel any of your subscriptions, please email us at <a :href="'mailto:' + cs_mail_address" class="mailto">{{  cs_mail_address }}</a>.</span></div>-->
                <!--                <div class="text-center" style="padding: 20px;"><span class="text-center">All cancellation are subject to notice of 30 days.</span></div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col col-12 text-center">
            <span v-if="cb_subscription_id === '' || cb_subscription_id === null" style="display: block">
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="backStep()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Cancel</span>
              </a>
            </span>
            <span v-else style="display: block">
               <a href="#" class="btn btn-primary" @click="handleCancelSubscription()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Request Cancellation</span>
              </a>
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="backStep()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Cancel</span>
              </a>
            </span>
          </div>
        </div>
      </div>
      <span
        class="modal-close"
        @click="hideModal">
          <svg-rndr svg="close.svg" />
      </span>
    </modal>
    <!--subscribe model-->
    <modal
      name="subscribe-modal"
      width="100%"
      height="auto">
      <div style="display: block !important; width: 100% !important;">
        <div class="row no-gutters">
          <div class="col col-12">
            <div class="text-center">
              <p class="h5" style="font-weight: 800">{{ dialogTitle }}</p>
            </div>
            <div>
              <div>
                <div class="text-center" style="padding: 20px;"><span class="text-center" style="font-weight: 300;">{{ passData.Subscription_Description__c }}</span></div>
<!--                <div class="text-center" style="padding: 20px;"><span class="text-center" style="font-weight: 500; font-size: 16px;">Subscribe to this package?</span></div>-->
<!--                <div class="text-center">-->
<!--                  <p class="h5" v-if="price">${{ Number(price).toLocaleString(undefined, { minimumFractionDigits: 2 }) }} per year</p>-->
<!--                </div>-->
                <div style="display: table; height: 160px; overflow: hidden; width: 100%; padding: 20px; background-color: #4f6da0 !important; margin-bottom: 20px !important; margin-top: 20px !important;">
                  <div style="display: table-cell; vertical-align: middle; text-align: center">
                    <div>
                    <span class="text-center cancel-emp-text">
                     To upgrade or manage any of your subscriptions, please email us at <a :href="'mailto:' + cs_mail_address" class="mailto">{{ cs_mail_address }}</a>.
                    </span>
                    </div>
                  </div>
                </div>
                <div v-if="show_card_form === true" class="card-content">
                  <CardComponent
                    ref="card"
                    class="fieldset field"
                    :styles="styles"
                    :classes="classes"
                    :locale="locale"
                    :placeholder="placeholder"
                    :fonts="fonts">
                    <div class="form-group">
                      <label class="cb-input-card-label">Credit Card Number *:</label>
                      <CardNumber
                        ref="cardNumber"
                        class="form-control cb-input-card"/>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">Expiry *:</label>
                        <CardExpiry
                          ref="cardExpiry"
                          class="form-control cb-input-card"/>
                      </div>
                      <div class="form-group col-md-6">
                        <label class="cb-input-card-label">CVC *:</label>
                        <CardCvv
                          ref="cardCvv"
                          class="form-control cb-input-card"/>
                      </div>
                    </div>
                  </CardComponent>
                </div>
              </div>
            </div>
          </div>
          <!--            <span style="display: block; width: 100%; text-align: center; padding-top: 20px; padding-bottom: 30px;">-->
          <!--              <a v-for="ops in selectedOptions" href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="openOptions()" style="margin-right: 20px;">-->
          <!--                <span data-current-language="tr_TR">{{ ops.Name }} - {{ ops.Price__c }}</span>-->
          <!--              </a>-->
          <!--            </span>-->
        </div>
        <div class="row no-gutters">
          <div class="col col-12 text-center">
            <span style="display: block">
<!--              <a href="#" class="btn btn-primary" @click="getToken" style="margin-right: 20px;">-->
<!--                <span data-current-language="tr_TR">Confirm</span>-->
<!--              </a>-->
              <a href="#" class="btn btn-outline-primary btn-outline-subscribed" @click="hideModal()" style="margin-right: 20px;">
                <span data-current-language="tr_TR">Cancel</span>
              </a>
            </span>
          </div>
        </div>
      </div>

      <span
        class="modal-close"
        @click="hideModal">
          <svg-rndr svg="close.svg" />
      </span>

    </modal>
  </div>
</template>

<script>
import {CardComponent, CardNumber, CardExpiry, CardCvv} from '@chargebee/chargebee-js-vue-wrapper';
import CustomSelect from '@C/CustomSelect';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: 'Subscriptions',
  components: {
    // ModalReview,
    CardComponent,
    CardNumber,
    CardExpiry,
    CardCvv,
    Loading,
    CustomSelect
  },
  props: {
    subscriptions_data: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isLoading: false,
      bg_color: '#000',
      icon_color: '#fff',
      fullPage: true,
      dialogOptions: false,
      dialogTitle: '',
      selectedOptions: [],
      subscriptionData: [],
      subscriptions: [],
      all_products: [],
      base_url: window.ENV.BASE_URL,
      default_icon: window.ENV.BASE_URL + '/img/subscriptions/learnforex.svg',
      cs_mail_address: window.ENV.CS_MAIL_ADDRESS,
      result: [],
      combi_result: [],
      customer_group: '',
      chargebee_subscription_id: '',
      cb_subscription_id: '',
      subscriptionStatus: '',
      price: '',
      passData: '',
      billings: '',
      sf_subscription_id: '',
      show_billing_tab: 0,
      cb_token_id: '',
      btn_caption: 'Subscribed',
      //Chargebee
      token: "",
      errMsgToken: "",
      loading: false,
      firstName: "",
      // data_set: {},
      billing_count: 0,
      next_due_date: 'YYYY-MM-DD',
      tocancelData: '',
      term: '',
      access_to_subscription: '',
      to_take: '',
      show_card_form: false,
      nextdue_is_morethan: false,
      cancel_step: 1,
      options: [{
        value: 'Manage Subscription',
        label: 'Manage Subscription'
      }],
      // Options for card-component
      // custom classes
      classes: {
        focus: "focus",
        invalid: "invalid",
        empty: "empty",
        complete: "complete",
      },
      // Custom fonts
      fonts: ["https://fonts.googleapis.com/css?family=Lato:400,700"],
      // Placeholders
      placeholder: {
        number: "Card Number",
        cvv: "CVV",
        expiry: "MM / YY",
      },
      // Locale
      locale: "en",
      // Custom styles
      styles: {
        base: {
          color: '#39467b',
          fontWeight: 600,
          fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',

          ':focus': {
            color: '#424770'
          },

          '::placeholder': {
            color: '#9BACC8'
          },

          ':focus::placeholder': {
            color: '#CFD7DF'
          }
        },
        invalid: {
          color: '#39467b',
          ':focus': {
            color: '#FA755A'
          },
          '::placeholder': {
            color: '#FFCCA5'
          }
        }
      },
      errors: {},
      errorMessage: '',
      data_set: {}
    }
  },
  filters: {
    subMonth(date) {
      var d = new Date(date).getDay()
      var m = new Date(date).getMonth()
      var y = new Date(date).getFullYear()

      let new_date = d + '/' + m + '/' + y
      return new_date;
    },
    formatDate(date) {
      var d = new Date(date);

      var datestring = d.getFullYear()  + "-" + (d.getMonth()+1) + "-" + d.getDate()
      return datestring
    },
    formatPrice(price) {
      return price / 100;
    },
    toCurrency(n) {
      let amountTrim = parseInt(n)  / 100;
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })
      return formatter.format(amountTrim);
    },
  },
  created() {
    this.getSubscriptions()
    this.billing_count = this.data_set.billing.length
    if(this.billing_count > 0) {
      this.show_card_form = false
    }
  },
  methods: {
    handleChangeStep() {
      this.cancel_step = 2
    },
    backStep(value) {
      this.cancel_step = 1
    },
    reloadSubscription(value) {
      if(value === 1) {
        this.isLoading = true
        let url = "/widget/get-subscriptions";
        axios.post(url)
          .then(response => {

            this.data_set = response.data
            this.getSubscriptions()
            this.isLoading = false
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
      } else {
        this.data_set = this.subscriptions_data
        this.getSubscriptions(value)
      }
    },
    getSubscriptions(value) {
      if(value) {
        this.data_set = value
      } else {
        this.data_set = this.subscriptions_data
      }
      let subscriptions = []
      let combiproducts = []
      let combifinal = []
      subscriptions = this.data_set.subscriptions
      // combiproducts = []
      combiproducts = this.data_set.all_products
      this.customer_group = this.data_set.customer_group
      this.billings = this.data_set.billing
      this.billing_count = this.data_set.billing.length
      this.show_billing_tab = this.data_set.show_billing_tab

      let new_arr = []

      if(combiproducts.length > 0) {
        combiproducts.forEach((value, index) => {
          new_arr.push(value.combi_products)
          new_arr[index]['plan_id'] = value.purchase_options[0].Chargebee_Plan_ID__c
          new_arr[index]['sf_subscription_id'] = value.purchase_options[0].Id
          new_arr[index]['price'] = value.purchase_options[0].Price__c
          new_arr[index]['combi_product_id'] = value.combi_products.Id
          new_arr[index]['purchase_option_id'] = value.purchase_options[0].Id
          new_arr[index]['purchase_option_number'] = value.purchase_options[0].Purchase_Option_Number__c
        })

        Array.prototype.push.apply(new_arr,subscriptions)
        // console.log(new_arr,'new_arr')
        this.combi_result = new_arr
        // combiproducts.forEach((v, index) => {
        //   combifinal.push(v.combi_products)
        //   this.combi_result.push(v.combi_products)
        //   this.combi_result[index]['plan_id'] = v.purchase_options[0].Chargebee_Plan_ID__c
        //   this.combi_result[index]['sf_subscription_id'] = v.purchase_options[0].Id
        //   this.combi_result[index]['price'] = v.purchase_options[0].Price__c
        //   this.combi_result[index]['combi_product_id'] = v.combi_products.Id
        //   this.combi_result[index]['purchase_option_id'] = v.purchase_options[0].Id
        //   this.combi_result[index]['purchase_option_number'] = v.purchase_options[0].Purchase_Option_Number__c
        // })
        this.result = []
        // if(this.combi_result.length > subscriptions.length) {
        // -------
        new_arr.forEach((v, index) => {
          if (subscriptions.length > 0) {
            subscriptions.forEach((valuex, IndexInner) => {
              if (valuex.Id === v.Id) {
                if (valuex.purchaseOption) {
                  new_arr[index]['subscriptionStatus'] = valuex.subscriptionStatus
                  // this.combi_result[index]['price'] = ''
                  new_arr[index]['subscription_id'] = valuex.subscriptionId
                  new_arr[index]['price'] = valuex.purchaseOption.Price__c
                  new_arr[index]['purchase_option_number'] = valuex.purchaseOption.Purchase_Option_Number__c
                  new_arr[index]['status'] = valuex.status
                  new_arr[index]['subs_end'] = this.endSubs(valuex, 0)
                  new_arr[index]['last_access'] = this.get_last_access(valuex, 0)
                  new_arr[index]['next_due_date'] = valuex.next_due_date
                  new_arr[index]['chargebee_subscription_id'] = valuex.chargebee_subscription_id
                } else {
                  new_arr[index]['price'] = ''
                  new_arr[index]['purchase_option_number'] = ''
                }
              } else {
              }
            })
          } else {
            new_arr[index]['subscriptionStatus'] = 'subscribe'
          }
        })
        var resArr = [];
        new_arr.forEach(function(item){
          var i = resArr.findIndex(x => x.Id == item.Id);
          if(i <= -1){
            resArr.push(item);
          }
        });
        this.subscriptions = resArr
      } else {
        subscriptions.forEach((value, index) => {
          if(value.purchaseOption) {
            subscriptions[index]['subscriptionStatus'] = value.subscriptionStatus
            // this.combi_result[index]['price'] = ''
            subscriptions[index]['subscription_id'] = value.subscriptionId
            subscriptions[index]['purchase_option_number'] = value.purchaseOption.Purchase_Option_Number__c
            subscriptions[index]['price'] = value.purchaseOption.Price__c
            subscriptions[index]['status'] = value.status
            subscriptions[index]['subs_end'] = this.endSubs(value , 0)
            subscriptions[index]['next_due_date'] = value.next_due_date
            subscriptions[index]['chargebee_subscription_id'] = value.chargebee_subscription_id
          } else {
            subscriptions[index]['purchase_option_number'] = ''
            subscriptions[index]['price'] = ''
          }
        })
        this.subscriptions = subscriptions

      }
    },
    handleChange(value) {
      if(value === 1) {
        this.btn_caption = 'Cancel Subscription'
      } else {
        this.btn_caption = 'Subscribed'
      }
    },
    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    },
    endSubs(value) {
      var next_due = new Date(value.next_due_date)
      let to_take = ''
      if(this.next_due_date !== '') {
        var end_access = ''
        let term = value.purchase_option_number
        var now = new Date()
        var myDate = moment(now).add(29,'d')
        if(next_due <= myDate) {
          end_access = moment(next_due).add(term,'M')
          this.nextdue_is_morethan = true
        } else {
          end_access = next_due // - 1 day
          this.nextdue_is_morethan = false
        }

        let thisdate = moment(end_access).subtract(1,'d')
        to_take = moment(thisdate).format('DD-MM-YYYY')

      }
      return to_take
    },
    get_last_access(value) {
      this.chargebee_subscription_id = value.chargebee_subscription_id
      this.selectedOptions = value.pricing

      let x_date = new Date(value.next_due_date)
      this.next_due_date = moment(x_date).format('DD-MM-YYYY')
      if(value.purchase_option_number === 12) {
        this.term = 'year'
      } else if(value.purchase_option_number === 6) {
        this.term = 'bi-annual'
      } else {
        this.term = 'month'
      }
      if(this.next_due_date !== '') {
        var next_due = new Date(this.next_due_date)
        var end_access = ''
        let term = value.purchase_option_number
        var now = new Date()
        var myDate = moment(now).add(29,'d')
        if(next_due <= myDate) {
          end_access = moment(next_due).add(term,'M')
          this.nextdue_is_morethan = true
          let thisdate = moment(end_access).subtract(1,'d')
          this.to_take = moment(thisdate).format('DD-MM-YYYY')
        } else {
          end_access = this.next_due_date // - 1 day
          this.nextdue_is_morethan = false
          this.to_take = end_access
        }
      }

      this.sf_subscription_id = value.subscription_id
      this.tocancelData = value
      this.cb_subscription_id = value.chargebee_subscription_id
      // console.log(this.tocancelData , 'tocancelData')
      this.dialogTitle = value.Name
      this.price = value.price
      // this.$modal.show('options-modal');
    },
    openOptions(value) {
      this.chargebee_subscription_id = value.chargebee_subscription_id
      this.selectedOptions = value.pricing
      // this.next_due_date =

      let x_date = new Date(value.next_due_date)
      this.next_due_date = moment(x_date).format('DD-MM-YYYY')
      // console.log(this.next_due_date,'test 1')
      if(value.purchase_option_number === 12) {
        this.term = 'year'
      } else if(value.purchase_option_number === 6) {
        this.term = 'bi-annual'
      } else {
        this.term = 'month'
      }
      // temporary?
      // this.next_due_date = '12/5/2020'
      if(this.next_due_date !== '') {
        var next_due = new Date(this.next_due_date)
        var end_access = ''
        let term = value.purchase_option_number
        var now = new Date()
        var myDate = moment(now).add(29,'d')
        if(next_due <= myDate) {
          end_access = moment(next_due).add(term,'M')
          this.nextdue_is_morethan = true
          let thisdate = moment(end_access).subtract(1,'d')
          this.to_take = moment(thisdate).format('DD-MM-YYYY')
        } else {
          end_access = this.next_due_date // - 1 day
          this.nextdue_is_morethan = false
          // let thisdate = moment(end_access).subtract(1,'d')
          this.to_take = end_access
          // console.log(this.next_due_date, 'else')
        }
      }

      this.sf_subscription_id = value.subscription_id
      this.tocancelData = value
      this.cb_subscription_id = value.chargebee_subscription_id
      // console.log(this.tocancelData , 'tocancelData')
      this.dialogTitle = value.Name
      this.price = value.price
      this.$modal.show('options-modal');
    },
    hideModal() {
      this.$modal.hide('options-modal');
      this.$modal.hide('subscribe-modal');
      this.cancel_step = 1
    },
    handleSubscribeModal(value) {
      this.chargebee_subscription_id = value.chargebee_subscription_id
      this.dialogTitle = value.Name
      this.price = value.price
      this.passData = value
      this.$modal.show('subscribe-modal');
    },
    getToken (e) {
      e.preventDefault()
      this.isLoading = true
      if(this.billing_count === 0) {
        this.$refs.card
          .tokenize({})
          .then((data) => {
            this.cb_token_id = data.token;
            this.handleSubscribe()
            // this.$refs.cardComponent.tokenize().then(data => {
          }).catch(error => {
          console.log(error)
          this.$toasted.show('Invalid Card Details!', {
            type : 'error',
            // icon : 'error_outline',
            position: 'top-center',
            duration: 3000,
          })
          this.isLoading = false
        })
      } else {
        this.handleSubscribe()
      }
    },
    reloadData(data) {
      this.getSubscriptions(data)
    },
    handleSubscribe() {
      let url = "/widget/subscribe";
      axios.post(url,
        {
          // sf_subscription_id: this.passData.sf_subscription_id,
          plan_id: this.passData.plan_id,
          combi_product_id: this.passData.combi_product_id,
          purchase_option_id: this.passData.purchase_option_id,
          cb_token: this.cb_token_id
        })
        .then(response => {
          this.isLoading = false
          if(response.data.status === 'success') {
            this.$toasted.show('You have successfully subscribed!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })

            this.subscriptions = []
            this.combi_result = []
            this.data_set = {}
            this.$emit('changed')
            this.hideModal()
            this.isLoading = false
          } else {
            this.show_card_form = true
            this.$toasted.show(response.data.display_message, {
              type : 'error',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
            // this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })
    },
    handleCancelSubscription() {
      let url = "/widget/schedule-cancel-subscription";
      this.isLoading = true
      axios.post(url,
        {
          sf_subscription_id: this.sf_subscription_id,
          chargebee_subscription_id: this.chargebee_subscription_id
        })
        .then(response => {
          if(response.data.status === 'success') {
            this.$toasted.show('Subscription successfully canceled!', {
              type : 'success',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
            this.subscriptions = []
            this.combi_result = []
            this.data_set = {}
            this.$emit('changed')
            this.hideModal()
            this.isLoading = false
            // this.getSubscriptions()
          } else {
            this.$toasted.show(response.data.status, {
              type : 'error',
              // icon : 'error_outline',
              position: 'top-center',
              duration: 3000,
            })
            this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.$toasted.show('Error!', {
            type : 'error',
            // icon : 'error_outline',
            position: 'top-center',
            duration: 3000,
          })
          this.isLoading = false
        })
    }
  }
};
</script>
<style scoped>
.card-subscription {
  border: none !important;
  padding-bottom: 1rem !important;
}

.card.card-subscription > .card-body {
  padding: 1rem !important;
}

a.btn-outline-subscribed {
  border: 1px solid rgba(255, 255, 255, .25);
  color: #fff !important;
}

.card-content {
  background-image: none !important;
  background-color: #455c8c !important;
  border-radius: 3px !important;
  margin-top: 20px !important;
  padding: 20px !important;
}

label.cb-input-card-label {
  margin-bottom: 10px !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.subs-card-content-title {
  margin-top: 14px !important;
  min-height: 42px !important;
  font-size: 18px !important;
  font-weight: 400 !important;
  font-family: sans-serif !important;
  margin-bottom: 15px !important;
}

span.cancel-emp-text {
  padding: 20px !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

/* Dropdown Button */
.dropbtn {
  background-color: transparent !important;
  color: #141944;
  /*padding: 16px;*/
  font-size: 16px;
  border: none;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #38447b !important;
  min-width: 160px;
  -webkit-box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  margin-left: -3px;
  /* margin-top: 10px; */
}

/* Links inside the dropdown */
.dropdown-content a {
  color: #9e9e9e;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  /*background-color: #ddd;*/
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {display: block;}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {background-color: #3e8e41;}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #f3f3f3;
  /* padding-top: 20px !important; */
  margin-top: 10px !important;
  position: absolute !important;
  margin-left: 5px !important;
}

span.btn.cancelled-btn {
  background-image: none !important;
}

span.cancellation-message {
  color: rgba(255, 255, 255, .42);
  /* position: absolute; */
  /* width: 100%; */
  /*margin-top: 130px;*/
  display: block;
}
a.mailto {
  color: #ffffff !important;
  font-weight: bold;
  text-decoration: underline;
}

span.cancellation-message-1 {
  min-height: 35px !important;
  display: inline-block !important;
}

.toasted-container.top-center {
  top: 30% !important;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  display: block;
}

</style>




// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Tabs/Subscriptions.vue